import * as PropTypes from "prop-types";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import GlobalMessages from "messages/messages";
import FormattedDate, {
  DATE_FORMATS,
} from "basicComponents/FormattedDate/Formatted";
import ActionButton from "basicComponents/ActionButton/ActionButton";
import ResultImage from "images/bestProduct.png";
import history from "utils/history";
import messages from "./messages";
import Header from "../../../basicComponents/Header/Header";
import LinkButton from "../../../basicComponents/LinkButton/LinkButton";
import moment from "moment";

export default function ConclusionPage({ result, onContinue }) {
  const preparation = moment(
    result.planned_date_time_from,
    DATE_FORMATS.BUMBAL,
  ).subtract(10, "m");
  const wrapUp = moment(result.planned_date_time_to, DATE_FORMATS.BUMBAL).add(
    10,
    "m",
  );

  return (
    <Container>
      <Wrapper data-cy="conclusionPage" style={{background:'white'}}>
        <HeaderContainer>
          <Header>
            <FormattedMessage {...messages.header} />
          </Header>
        </HeaderContainer>
        <Horizontal>
          <Content>
            <Field
              name={<FormattedMessage {...GlobalMessages.date} />}
              value={
                <FormattedDate
                  date={result.planned_date_time_from}
                  format={DATE_FORMATS.HUMAN_READABLE_DATE}
                  inputFormat={DATE_FORMATS.BUMBAL}
                />
              }
            />
            <Field
              name={<FormattedMessage {...GlobalMessages.preparation} />}
              value={
                <FormattedDate
                  date={preparation}
                  format={DATE_FORMATS.HUMAN_READABLE_TIME}
                />
              }
            />
            <Field
              name={<FormattedMessage {...messages.fromTime} />}
              value={
                <FormattedDate
                  date={result.planned_date_time_from}
                  format={DATE_FORMATS.HUMAN_READABLE_TIME}
                  inputFormat={DATE_FORMATS.BUMBAL}
                />
              }
            />
            <Field
              name={<FormattedMessage {...messages.toTime} />}
              value={
                <FormattedDate
                  date={result.planned_date_time_to}
                  format={DATE_FORMATS.HUMAN_READABLE_TIME}
                />
              }
            />
            <Field
              name={<FormattedMessage {...GlobalMessages.wrapUp} />}
              value={
                <FormattedDate
                  date={wrapUp}
                  format={DATE_FORMATS.HUMAN_READABLE_TIME}
                />
              }
            />
            <Field
              name={<FormattedMessage {...GlobalMessages.duration} />}
              value={
                <span>
                  {result.durationMin / 60}{" "}
                  <FormattedMessage {...GlobalMessages.hoursFull} />
                </span>
              }
            />
          </Content>
          <ImageWrapper>
            <ImageContainer src={ResultImage} />
          </ImageWrapper>
        </Horizontal>
      </Wrapper>
      <ActionButton id="continueButton" onClick={onContinue}>
        <FormattedMessage {...messages.planAnother} />
      </ActionButton>
      <LinkButton onClick={toDashboard}>
        <FormattedMessage {...GlobalMessages.go_back_to_dashboard} />
      </LinkButton>
    </Container>
  );
}

ConclusionPage.propTypes = {
  result: PropTypes.object.isRequired,
  onContinue: PropTypes.func.isRequired,
};

function toDashboard() {
  history.push("/dashboard");
}

function Field({ name, value }) {
  return (
    <FieldWrapper>
      <LeftSpan>{name}</LeftSpan>
      <RightSpan>{value}</RightSpan>
    </FieldWrapper>
  );
}

Field.propTypes = {
  name: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
};

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 2;
  max-width: 10rem;
  flex-direction: column;
  padding: ${({ theme }) => theme.margin}rem;
  object-fit: contain;
`;

const Horizontal = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const ImageContainer = styled.img`
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  ${({ theme }) => theme.tabletLandscapeUp`
    min-width: 40rem;
  `};
`;

const RightSpan = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  width: 50%;
`;

const LeftSpan = styled.div`
  width: 50%;
`;

const FieldWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const Content = styled.div`
  padding: ${({ theme }) => theme.padding}rem;
  flex-shrink: 2;
  flex-grow: 2;
`;

const HeaderContainer = styled.div`
  padding: ${({ theme }) => theme.padding}rem;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
`;

const Wrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius};
  width: 100%;
  margin-bottom: ${({ theme }) => theme.margin}rem;
`;
